import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/core/app";
import "@/core/i18n";
import "@/puzzle-types";
import "@/games";
import "@/duels";
import "@/index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
